<template>
  <div id="ty_tx" class="tc" @touchmove.prevent>
    <div class="shell absoluteItem centerImg" @click.stop>
      <span class="close absoluteItem centerX" @click="close_self"></span>
      <div class="main">
        <p class="p1">提现金额</p>
        <div class="txshell relativeItem">
          ￥<input
            type="text"
            class="tx-input"
            placeholder="请输入提现金额"
            v-model="money"
          />
          <span class="absoluteItem" @click="get_all">全部提现</span>
        </div>
        <p class="p3">请等待审核，通过后会及时到账</p>

        <div class="item phone">
          <span>联系电话</span>
          <input
            type="text"
            maxlength="11"
            placeholder="请输入联系电话"
            v-model="phone"
          />
        </div>

        <div class="item relativeItem">
          <span>验证码</span>
          <input type="text" maxlength="6" placeholder="请输入验证码" v-model="code" />
          <i class="absoluteItem centerY" :class="{ unable: !getCode }" @click="gcode">{{
            yzm_text
          }}</i>
        </div>
      </div>
      <button @click="tx" :class="{ unable: !allow_click }">确认提现</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ty_tx",
  props: ["allmoney"],
  data() {
    return {
      money: "",
      phone: "",
      code: "",
      getCode: true,
      yzm_text: "获取验证码",
      allow_click: true, //禁止重复点击按钮的标识
      max_money:5000,//一次性最多提现金额
      beishu:100,//提现金额的倍数
    };
  },
  methods: {
    /**通知父元素关闭自己 */
    close_self() {
      this.money = "";
      this.phone = "";
      this.code = "";
      this.$emit("closetx");
    },

    /**获取手机验证码 */
    gcode() {
      //判断手机号码是否完整
      if (!this.$tool.checkPhone(this.phone)) {
        this.$tool.tip("请填写正确的手机号码", "20%");
        return;
      }

      //判断是否能发送验证码
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }

      let _this = this;
      let data = {
        mobile: this.phone,
      };
      this.$jsonp(this.$apis("ty_msg"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.yzm_text = "重新发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.yzm_text = "获取验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else {
          _this.getCode = true;
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },

    /**点击全部提现 */
    get_all() {
      if (parseInt(this.allmoney * 1) > 5000) {
        this.money = 5000;
      } else {
        this.money = this.allmoney;
      }
    },

    /**点击提现 */
    tx() {
      if (parseInt(this.money * 1) == 0) {
        this.$tool.tip("您可提现金额不足，赶快去分享赚收益吧！", "30%");
        return false;
      }
      //查看金额是否为100的整倍数
      if (
        (parseInt((this.money * 1) % this.beishu) != 0 && this.money != 0) ||
        this.money == ""
      ) {
        this.$tool.tip(`提现金额只能为${this.beishu}的倍数`);
        return false;
      }
      if (parseInt(this.money * 1) > 5000) {
        this.$tool.tip("单次提现最多不能超过5000");
        return false;
      }
      if (!this.$tool.checkPhone(this.phone)) {
        this.$tool.tip("请输入正确的手机号码");
        return false;
      }
      if (this.code == "") {
        this.$tool.tip("请输入验证码");
        return false;
      }
      //禁止重复点击
      if (this.allow_click) {
        this.allow_click = false;
      } else {
        return false;
      }
      let _this = this;
      let data = {
        mobile: this.phone,
        money: this.money,
        code: this.code,
      };
      this.$jsonp(this.$apis("ty_tx"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tipImg("操作成功", "success");
          setTimeout(() => {
            _this.money = "";
            _this.phone = "";
            _this.code = "";
            _this.$emit("closetx", "刷新页面");
          }, 1500);
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
        _this.allow_click = true;
      });
    },
  },
  mounted: function () {},
  watch: {
    money(val) {
      if (parseInt(val) > this.max_money) {
        this.money = this.max_money;
      }else{
        this.money = val.replace(/^\D(\d(?:.\d{0,2})?)./g, "1");
      }
      
    },
    phone(val) {
      this.phone = val.replace(/\D/g, "");
    },
    code(val) {
      this.code = val.replace(/\D/g, "");
    },
  },
};
</script>

<style scoped>
.tc {
  background: rgba(0, 0, 0, 0.6);
}
.close {
  width: 29px;
  height: 29px;
  background: url("../../assets/tyimg/ty(29).png") left top no-repeat;
  background-size: 100%;
  top: -50px;
}
.shell {
  width: 85%;
}
.main {
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 15px;
  padding: 12px;
}
button {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  padding: 11px 0;
  text-align: center;
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(to right, #ff7d62, #fe4f3f);
}

.main .p1 {
  font-size: 11px;
  margin-bottom: 20px;
}
.txshell {
  font-size: 21px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px dashed #ffb8b7;
  margin-bottom: 13px;
}
.txshell span {
  border-radius: 3rem;
  background: #fe6e54;
  font-size: 9px;
  padding: 5px 11px;
  right: 5%;
  top: 3px;
  color: #fff;
}
.main .tx-input {
  position: relative;
  background: none;
  font-size: 22px;
  font-weight: bold;
  width: 80%;
  box-sizing: border-box;
}
.main .tx-input::-webkit-input-placeholder {
  color: #ccc;
  font-weight: 400;
}
.main .p3 {
  font-size: 11px;
  color: #999;
  margin-bottom: 10px;
}

.item {
  margin-bottom: 16px;
}
.item span {
  display: inline-block;
  width: 55px;
  font-size: 11px;
  color: #333;
}
.item input {
  box-sizing: border-box;
  background: none;
  font-size: 11px;
  color: #333;
}
.item input::-webkit-input-placeholder {
  color: #ccc;
}
.phone input {
  color: #fe6e54;
}
.item i {
  font-style: normal;
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  text-align: center;
  padding: 6px;
  width: 23%;
  right: 5px;
  background: #00aaff;
}
.item .unable {
  background: #cdcdcf;
}
.unable {
  background: #cdcdcf;
}
</style>
